export const filterNullable = <T extends object>(object: T) =>
    Object.fromEntries(Object.entries(object).filter(([, value]) => value !== null && value !== undefined)) as { [name in keyof T]-?: NonNullable<T[name]> };
